import { render } from "./Services.page.vue?vue&type=template&id=fd2f70d4&scoped=true&ts=true"
import script from "./Services.page.vue?vue&type=script&lang=ts"
export * from "./Services.page.vue?vue&type=script&lang=ts"

import "./Services.page.vue?vue&type=style&index=0&id=fd2f70d4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd2f70d4"]])

export default __exports__